import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getEmailHtml } from '../../requests/emails'
import { handleError } from '../../errors/handleError'
import { Page } from '../../components/Page'
import { Empty } from '../../components/Empty'
import './styles.css'

export const ViewEmailContent: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [html, setHtml] = useState<string>('')
  const { inboxId, emailId } = useParams<{ inboxId: string; emailId: string }>()

  useEffect(() => {
    const fetchHtml = async () => {
      if (!inboxId || !emailId) {
        return
      }

      try {
        const res = await getEmailHtml(inboxId, emailId)
        setHtml(res.data)
        setLoading(false)
      } catch (err) {
        setHtml('')
        handleError(err, 'Failed to fetch this email\'s content. Please try again later.')
        setLoading(false)
      }
    }

    fetchHtml()
  }, [inboxId, emailId])

  if (loading) {
    return (
      <Page>
        <Link to={`/app/folders/${inboxId}/sources`}>
          <button className="secondary">
            Back to Sources
          </button>
        </Link>
        <br />
        <br />
        <Empty>
          ☕️ Brewing the content...
        </Empty>
      </Page>
    )
  }

  if (!html) {
    return (
      <Page>
        <Link to={`/app/folders/${inboxId}/sources`}>
          <button className="secondary">
            Back to Sources
          </button>
        </Link>
        <br />
        <br />
        <Empty>
          🤔 Hmmm... This email has no content. Try sending this email to this inbox again.
        </Empty>
      </Page>
    )
  }

  return (
    <Page>
      <Link to={`/app/folders/${inboxId}/sources`}>
        <button className="secondary">
          Back to Sources
        </button>
      </Link>
      <br />
      <br />
      <p>
        Note: If some links are not opening properly, try right-clicking them and opening in a new tab.
      </p>
      <iframe
        title="View this Email"
        srcDoc={html}
        style={{ width: '100%', height: '500px', border: 'none' }}
      />
    </Page>
  )
}
